export const EnInternationalFilename = 'en_international';
export const DummyFilename = 'dummy';
export const deploymentVersionParamName = "?v=";